module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAAXNSR0IArs4c6QAAAHtQTFRFAAAAzJlm/5lm/6qA/5Jt359g46px9aNw8aN48qN28qZz9qd08qZ08qZz86Z48KR08aV186V18aV08aR18qR08aV18qR18aR18qR28aR28aR28aR18aR18aR18qR28qR18aV18qR18aR18aR08KN18aR08aN18aR18aR17gHcawAAACh0Uk5TAAUFBgcICRkkJyg3OTxCeXx8f4OGkK6xsbS2ucrd5ufq7O/x8vP1+md4eOsAAACASURBVCjPfc5HDsJAAEPRT+8QSugh9Pj+J2QxINAwsXfWkyWzUCpVkfcA0ipdJlbtNsdoQZ0ez6qo0XVjI5HWbXOlL370+ZCkXWupX3zrfHCS9u1QiPQ+HpaHTqYYg95G/e5M/xj0Os2UwvgzTnGKU5ziFKc4xSlOcYpTnOIUpy8DhDkmu1cNqAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gouxuan_bg.png
// module id = sGDx
// module chunks = 62